// extracted by mini-css-extract-plugin
module.exports = {"component":"CartColumn_component__CnmDQ"};